import { IconCup } from '@tabler/icons-react';
import ButtonModify from './ButtonModify';
import DeleteIconCircle from './DeleteIconCircle';

export default function AddedCart({ name, price, image, variants = [], quantity = 1, onModify, onDelete }) {
  const variantNames = variants
    .map((v) => (typeof v === 'string' ? v : v?.option_name))
    .filter(Boolean);

  const variantSummary =
    variantNames.length > 0
      ? variantNames.join(' · ')
      : variants.length > 0
        ? `${variants.length} ${variants.length === 1 ? 'variante' : 'variantes'}`
        : '';

  return (
    <div
      className="flex items-start gap-3.5 rounded-2xl p-3.5 relative overflow-hidden"
      style={{
        backgroundColor: '#141414',
        fontFamily: '"Public Sans", sans-serif',
      }}
    >
      <div
        className="w-14 h-14 shrink-0 rounded-xl flex items-center justify-center overflow-hidden"
        style={{ backgroundColor: 'rgba(255, 255, 255, 0.04)' }}
      >
        {image ? (
          <img src={image} alt={name} className="w-12 h-12 object-contain" />
        ) : (
          <IconCup size={24} color="rgba(255, 255, 255, 0.3)" stroke={1.25} />
        )}
      </div>

      <div className="flex flex-col flex-1 min-w-0">
        <div className="flex items-baseline justify-between gap-3">
          <span
            className="font-semibold truncate"
            style={{
              fontSize: '15px',
              lineHeight: '20px',
              letterSpacing: '-0.01em',
              color: 'rgba(255, 255, 255, 0.95)',
            }}
            title={name}
          >
            {name}
          </span>

          <div
            className="flex items-baseline gap-1.5 shrink-0"
            style={{ fontVariantNumeric: 'tabular-nums' }}
          >
            {quantity > 1 && (
              <span className="font-medium" style={{ fontSize: '13px', color: 'rgba(255, 255, 255, 0.45)' }}>
                ×{quantity}
              </span>
            )}
            <span
              className="font-semibold"
              style={{ fontSize: '15px', lineHeight: '20px', letterSpacing: '-0.01em', color: 'rgba(255, 255, 255, 0.95)' }}
            >
              ${price}
            </span>
          </div>
        </div>

        {variantSummary && (
          <p
            className="m-0 mt-0.5 truncate"
            style={{
              fontSize: '12.5px',
              lineHeight: '18px',
              fontWeight: 500,
              color: 'rgba(255, 255, 255, 0.4)',
            }}
            title={variantSummary}
          >
            {variantSummary}
          </p>
        )}

        <div className="flex items-center justify-between gap-2 mt-3">
          <ButtonModify onClick={onModify}>Modificar</ButtonModify>
          <DeleteIconCircle onClick={onDelete} solid />
        </div>
      </div>
    </div>
  );
}
